export default "/assets/website/images/hamburger.svg?a69430cc781f1ce4c583f82422e483d4";